import React, { useState, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Typography, Box } from "@mui/material/";
import { makeStyles } from "@mui/styles";

import { TextField } from "@mui/material";
import Alert from "@mui/material/Alert";
import { addDoc, collection, db } from "../../firebase";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import emailjs from "@emailjs/browser";
import Menu from "./Menu";

const Contact = () => {
  let { id } = useParams();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);

  let orderMsg = "";

  if (id) {
    orderMsg = `<div>Customer send this email regarding about this order ID: ${id}</div>`;
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const onSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  // const docRef = await addDoc(collection(db, "mail"), {
  //   to: toSend.reply_to,
  //   message: {
  //     subject: "[Heslet Contact Us]",
  //     html: `<!DOCTYPE html>
  //     <html lang="en">
  //     <head>
  //         <meta charset="UTF-8">
  //         <meta http-equiv="X-UA-Compatible" content="IE=edge">
  //         <meta name="viewport" content="width=device-width, initial-scale=1.0">
  //         <title>Thank you!</title><style>
  //             @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
  //             .myDiv {
  //                 font-family: 'Roboto', sans-serif;
  //               border: 1px solid lightgray;
  //               width:400px;
  //              margin-left:auto;margin-right:auto;padding-top:20px;padding-bottom:40px;
  //              padding-left:20px; padding-right:20px; line-height: 1.8em;
  //             }
  //             .logo{display:flex;  justify-content: space-between;}
  //             .confirm{top:+40px;position:relative}
  //             .blue{color:#153a5a; font-weight: bold;}
  //             .hello{padding-top:30px}
  //             .detail{padding-top:30px;border-bottom:1px solid lightgray;}
  //             .order{padding-top:20px}
  //             .green{color:#689f38}
  //             .custom_btn{background-color: #153a5b;cursor:pointer;
  //       color: white;
  //       letter-spacing: 3px;
  //       border-radius: 0;
  //       width: 100%;
  //       border: none;
  //       text-transform: uppercase;
  //       padding-top: 15px;
  //       padding-bottom: 15px;
  //       cursor: pointer;}
  //         .button{padding-top:20px}
  //         .ship{padding-top:20px}
  //         .Recommendations{padding-top:40px}
  //         .bottom{font-size: 11px;padding-top:50px;line-height: 1.5em;}
  //         .recomm{padding-top:20px; display:flex; font-size:13px;line-height: 1.5em;text-align: center;
  //         justify-content: space-evenly;}
  //         .custom_btn_whitebg {
  //       border: 1px #212a2f solid;
  //       color: black;
  //       letter-spacing: 3px;
  //       border-radius: 0;
  //       width: 100%;
  //       border: none;
  //       text-transform: uppercase;
  //       padding-top: 15px;
  //       padding-bottom: 15px;
  //       cursor: pointer;
  //     }

  //           </style>
  //     </head>
  //     <body>
  //         <div class="myDiv">
  //             <div class="logo"><img src="https://prism-a6a80.firebaseapp.com/img/heslet_logo.png" width="60" height="" />
  //             <div class="confirm" style="padding-top:50px; padding-left:30px;">Email from a Customer</div></div>
  //             <br />

  //            A customer sent a message from Helset.net.
  //      <br /><br />
  //           ${id && orderMsg}
  //           <div>Customer Name: ${toSend.reply_to}</div>
  //           <div>Customer Phone: ${toSend.phone}</div>
  //           <div>Message: ${toSend.message}</div>

  //             <div class="bottom">This email was sent from a notification-only address that cannot accept incoming email. Please do not reply to this message.</div>
  //         </div>
  //     </body>
  //     </html>`,
  //   },
  // });
  // setMsg((old) => t("Your message is sent. Thank you!"));
  // console.log("docRef", docRef);
  //   setLoading(false);
  // };

  const [toSend, setToSend] = useState({
    from_name: "",
    phone: "",
    message: "",
    user_email: "",
  });
  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
  };

  const classes = useStyles();
  const form = useRef();

  console.log("form.current", form);
  console.log("toSend", toSend);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    // Send it to the customer
    var templateParams1 = {
      ...toSend,
      reply_to: "rnwldms@gmail.com",
    };
    emailjs
      .send(
        "service_66owpwy",
        "template_wpppsrh",
        templateParams1,
        "user_7Zql27tiMF2NZkNx1LGdg"
      )
      .then(
        (result) => {
          console.log(result.text);
          setMsg((old) => t("Your message is sent. Thank you!"));
        },
        (error) => {
          console.log(error.text);
        }
      );

    // Send it to Heslet
    var templateParams2 = {
      ...toSend,
      customer_email: toSend.user_email,
      reply_to: "rnwldms@gmail.com",
      user_email: "rnwldms@gmail.com", // helset email
    };
    emailjs
      .send(
        "service_66owpwy",
        "template_aroxsrj",
        templateParams2,
        "user_7Zql27tiMF2NZkNx1LGdg"
      )
      .then(
        (result) => {
          console.log(result.text);
          setMsg((old) => t("Your message is sent. Thank you!"));
        },
        (error) => {
          console.log(error.text);
        }
      );
    setLoading(false);
    setTimeout(() => {
      setMsg(null);
    }, 2000);
  };

  return (
    <Grid
      container
      className={classes.product}
      sx={{ py: 6, width: 1, display: "flex" }}
    >
      <Menu current="contact" />
      <Grid item md={5} sx={{ pl: 7 }}>
        <Box
          variant="h5"
          sx={{
            fontSize: "15px",
            paddingTop: "10px",
            textDecoration: "none",
            color: "#153a5a",
          }}
        >
          {t("contact")}
        </Box>

        <Box
          sx={{
            paddingTop: "30px",
            fontWeight: "bold",
            fontSize: "18px",
            pb: { md: 0, sm: 2 },
          }}
        >
          {id && <div>{t("Help with Your Order")}</div>}
          {!id && <div>{t("contact2")}</div>}
        </Box>

        <Box
          sx={{ color: "#616161", pt: 2, lineHeight: "2.2em" }}
          dangerouslySetInnerHTML={{ __html: t("contact3") }}
        />
        <Box sx={{ mt: 5, backgroundColor: "#f5f5f5", p: 3 }}>
          <Box sx={{ fontWeight: 600 }}>헤즐릿 회사 안내</Box>
          <Box sx={{ mt: 1, lineHeight: "1.8em" }}>
            <Box>전화번호: +82 707-777-4524</Box>
            <Box>이메일: contact@heslet.net</Box>
            <Box>회사 주소: 서울 강서구 공항대로 190 푸리마타워 1316호</Box>
            <Box>개인정보보호책임자 : 장명기(mk@heslet.net)</Box>
            <Box>사업자 등록번호 안내 : 414-86-05122</Box>
            <Box>[사업자정보확인]통신판매업 신고 :</Box>
          </Box>
        </Box>
      </Grid>

      <Grid
        md={5}
        item
        // component="form"
        sx={{
          "& > :not(style)": { m: 1, width: "50ch" },
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          width: 1,
          alignItems: "center",
        }}
        noValidate
        autoComplete="off"
        // onSubmit={sendEmail}
      >
        {msg ? <Alert sx={{ fontSize: "12px" }}>{msg}</Alert> : null}

        {id && (
          <div>
            {t("Your Order ID")}: {id}
          </div>
        )}

        <form
          ref={form}
          onSubmit={sendEmail}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <TextField
            className={classes.inputs}
            type="text"
            name="from_name"
            variant="filled"
            label={t("your_name")}
            sx={{ mb: 2 }}
            onChange={handleChange}
          />
          <TextField
            type="text"
            name="phone"
            label={t("your phone")}
            variant="filled"
            sx={{ mb: 2 }}
            onChange={handleChange}
          />

          <TextField
            type="text"
            name="user_email"
            variant="filled"
            label={t("Your email")}
            sx={{ mb: 2 }}
            onChange={handleChange}
          />
          <TextField
            type="text"
            name="message"
            variant="filled"
            label={t("Your message")}
            className={classes.inputs}
            multiline
            rows={10}
            sx={{ mb: 2 }}
            onChange={handleChange}
          />

          <button type="submit" className="custom_btn" sx={{ width: "100%" }}>
            {loading ? t("... Sending") : t("send message")}
          </button>
        </form>
      </Grid>
    </Grid>
  );
};

export default Contact;

const useStyles = makeStyles({
  product: {},
  inputs: { backgroundColor: "white" },
});
